import { useCallback } from 'react';

import { Button, Box, useToast, VStack } from '@chakra-ui/react';

import { useAuth } from '@/context/AuthContext';
import { H3 } from '@/elements';
import {
  useProcessPaidPayoutLazyQuery,
  useProcessSellerPayoutLazyQuery,
} from '@/generated/core.graphql';

import ToastMessage from '../Display/ToastMessage';

const RunJobs = () => {
  const { self } = useAuth();
  const toast = useToast();
  const [processSellerPayoutLazyQuery] = useProcessSellerPayoutLazyQuery();
  const [processPaidPayoutLazyQuery] = useProcessPaidPayoutLazyQuery();

  const runProcessSellerPayout = useCallback(() => {
    processSellerPayoutLazyQuery({
      fetchPolicy: 'network-only',
    });

    toast({
      render: () => (
        <ToastMessage
          type='success'
          message={'Process Seller Payout job has been run.'}
        />
      ),
      duration: 3000,
    });
  }, [self]);

  const runProcessPaidPayout = useCallback(() => {
    processPaidPayoutLazyQuery({
      fetchPolicy: 'network-only',
    });

    toast({
      render: () => (
        <ToastMessage
          type='success'
          message={'Process Paid Payout job has been run.'}
        />
      ),
      duration: 3000,
    });
  }, [self]);

  return (
    <Box>
      <H3 mb='md'>Run Jobs</H3>
      <VStack alignItems='start' display='flex' gridGap={3}>
        <Button
          fontSize='12px'
          onClick={runProcessSellerPayout}
          padding='10px'
          height='32px'
        >
          Process Seller Payout
        </Button>
        <Button
          fontSize='12px'
          onClick={runProcessPaidPayout}
          padding='10px'
          height='32px'
        >
          Process Paid Payout
        </Button>
      </VStack>
    </Box>
  );
};

export default RunJobs;
